<div class="holes-status-chart-container">
  @if (typeChart === 'drilling') {
    <div>
      <div class="chart-header">
        {{ 'QAQC_TAB.DRILLING_PROGRESS' | translate }}
        <div class="chart-summary">
          <span class="total-holes">{{ 'QAQC_TAB.TOTAL_HOLES' | translate }}: {{ getTotalHoles() }} </span>
        </div>
      </div>
      <div class="chart-content">
        <div class="chart-legend">
          @for (item of statusData; track item) {
            <div class="legend-item">
              <div class="legend-color" [style.background-color]="item.color"></div>
              <span class="legend-label">{{ "HOLE." + item.status | uppercase | translate }}: {{ item.percentage }}%</span>
            </div>
          }
        </div>
        <div class="chart-canvas-container">
          <canvas #chartCanvas></canvas>
        </div>
      </div>
    </div>
  }

  @if (typeChart === 'loading') {
    <div>
      <div class="chart-header">
        {{ 'QAQC_TAB.LOADING_PROGRESS' | translate }}
        <div class="chart-summary">
          <span class="total-holes">{{ 'QAQC_TAB.TOTAL_HOLES' | translate }}: {{ getTotalHoles() }} </span>
        </div>
      </div>
      <div class="chart-content">
        <div class="chart-legend">
          @for (item of statusData; track item) {
            <div class="legend-item">
              <div class="legend-color" [style.background-color]="item.color"></div>
              <span class="legend-label">{{ "HOLE." + item.status | uppercase | translate }}: {{ item.percentage }}%</span>
            </div>
          }
        </div>
        <div class="chart-canvas-container">
          <canvas #chartCanvas></canvas>
        </div>
      </div>
    </div>
  }
</div>
